<template>
  <div :class="[size]">
    <label v-if="!!label" :for="id">{{ label }}</label>
    <textarea
      v-if="multiline"
      :id="id"
      :value="value"
      :placeholder="placeholder"
      :rows="rows"
      :disabled="disabled"
      @change="valueChanged"
      @input="valueChanged"
      @blur="$emit('blur', $event)"
      @keyup="$emit('keyup', $event)"
    ></textarea>
    <input
      v-else
      :id="id"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      @change="valueChanged"
      @input="valueChanged"
      @blur="$emit('blur', $event)"
      @keyup="$emit('keyup', $event)"
    />
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: () => (+new Date()).toString()
    },
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    multiline: {
      type: Boolean,
      default: () => false
    },
    size: {
      type: String,
      default: ''
    },
    rows: {
      type: Number,
      default: 5
    },
    type: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    valueChanged(e) {
      this.$emit('change', e.target.value);
      this.$emit('input', e.target.value);
    }
  }
};
</script>

<style lang="scss" scoped>
div {
  display: grid;
  grid-gap: 5px;
  grid-template-rows: max-content max-content;

  > * {
    min-width: 0;
    min-height: 0;
  }

  label {
    font-size: 0.75rem;
    font-weight: 500;
    letter-spacing: 0.025em;
  }

  input,
  textarea {
    // padding: 1rem;
    // transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    // border: 1px solid var(--theme-primary-dark);
    // border-radius: 0;
    // outline: none;
    // background: var(--theme-primary-dark);
    // color: var(--theme-on-primary);
    // font-family: inherit;
    // font-size: 0.85rem;
    // font-weight: 400;

    width: 100%;
    color: #2f3357;
    border-radius: 0px;
    box-shadow: none;
    // background-color: #f2f2f2;
    border: 1px solid rgb(45, 49, 61);
    font-size: 16px;
    padding: 10px 10px;
    margin: 0 12px 23px 0;
    box-sizing: border-box;
    font-family: Roboto;

    &:focus,
    &:active {
      outline: none;
    }

    &::-webkit-input-placeholder {
      opacity: 0.7;
      /* Chrome/Opera/Safari */
      color: var(--theme-on-primary);
    }
    &::-moz-placeholder {
      opacity: 0.7;
      /* Firefox 19+ */
      color: var(--theme-on-primary);
    }
    &:-ms-input-placeholder {
      opacity: 0.7;
      /* IE 10+ */
      color: var(--theme-on-primary);
    }
    &:-moz-placeholder {
      opacity: 0.7;
      /* Firefox 18- */
      color: var(--theme-on-primary);
    }

    &[disabled] {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  textarea {
    resize: none;
    // height: 62px;
  }
}
</style>
